import { render, staticRenderFns } from "./PropertyNew.vue?vue&type=template&id=a264e12a&scoped=true&lang=pug&"
import script from "./PropertyNew.vue?vue&type=script&lang=js&"
export * from "./PropertyNew.vue?vue&type=script&lang=js&"
import style0 from "./PropertyNew.vue?vue&type=style&index=0&id=a264e12a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a264e12a",
  null
  
)

export default component.exports